export const CHRONOX_PUBLIC_API_KEYS_DOCUMENT_INFO = {
    LINK: 'https://docs.chronox.ai/'
}